<template>
    <div>
  <span class='clickable-name' v-if='!editMode' @click.prevent.stop='edit()'>{{item[labelNome]}}</span>
  <div class='row'>
    <div class='col-md-4'>
      <input ref='inputName' :class="{'hidden' : !editMode }" type="text" class='form-control' v-model.trim='item[labelNome]'>
    </div>
    <div class="col-md-8" v-if='editMode'>
      <button title='Salvar' @click.prevent.stop='save()' class="btn btn-sm btn-success btn-icon"><i class="fa fa-check"></i></button>
      <button title='Cancelar' @click.prevent.stop='cancel()' class="btn btn-sm btn-danger btn-icon"><i class="fa fa-times"></i></button>
    </div>
  </div>
</div>
</template>
<script>

import OverlayService from '../services/overlay-service'

export default {
  props: {
    item: Object,
    service: Object,
    labelNome: String
  },

  data () {
    return {
      editMode: false
    }
  },

  methods: {
    edit () {
      this.prevName = this.item[this.labelNome]
      this.editMode = true

      this.$nextTick(() => {
        this.$refs.inputName.focus()
      })
    },

    cancel () {
      this.editMode = false
      this.item[this.labelNome] = this.prevName
    },

    save () {
      OverlayService.trigger('show', true)

      this.service
        .edit( this.item.id, { [this.labelNome]: this.item[this.labelNome] })
        .then(response => response.data)
        .then(item => {
          this.editMode = false
          this.$alertify.success('Nome salvo com sucesso!')
          OverlayService.trigger('show', false)
        })
        .catch(er => {
          this.$alertify.error('Erro ao editar nome')
          OverlayService.trigger('show', false)
        })
    }
  }
}
</script>

